<template>
    <div>
        <Card>
            <p slot="title">
                Assign Payment
            </p>
            <div>
                <template v-if="paymentPendingId">
                    <PaymentPendingRowCard :paymentPendingId="paymentPendingId" />
                </template>
                <br/>    
                <Card>
                    <p slot="title">
                        Search Payment
                    </p>
                    
                    <Row type="flex" justify="space-between" class="code-row-bg">
                        <Col span="4">
                            <SelectMarking  @on-selected-marking="onSelectedMarking" />                
                        </Col>
                        <Col span="4">
                            <DatePicker 
                                type="daterange" 
                                v-model="dateFromTo"
                                placeholder="Tanggal Pembayaran" 
                                split-panels 
                                style="width: 200px"></DatePicker>                
                        </Col>
                        <Col span="4">
                            <Button 
                                type="primary" 
                                :loading="loadingSearch"
                                @click="getPaymentPayNoDetail" 
                                icon="checkmark-round" 
                                size="small"  >
                                    <span v-if="!loadingSearch">Search</span>
                                    <span v-else>Wait.....</span>              
                            </Button>                
                        </Col>
                    </Row>              
                </Card>    
                <template v-if="payments.length > 0" >
                    <br/>
                    <h4> Found {{ payments.length }} payment</h4>
                    <br/>
                    <div v-for="payment in payments" :key="payment.id">
                        <PaymentRow 
                            :payment="payment" 
                            @on-selected-payment="postAssignPayment"
                            />
                    </div>                     
                </template>
            </div>
        </Card>

    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
// import _ from 'lodash'
import moment from 'moment'
// import UploadXls from '@/components/payment/UploadXls'
// import PaymentPendingRow from '@/components/payment/PaymentPendingRow'
import SelectMarking from '@/components/marking/SelectMarking'
import PaymentRow from '@/components/payment/PaymentRow'
import PaymentPendingRowCard from '@/components/payment/PaymentPendingRowCard'

const numeral = require('numeral');

export default {
    // components : { UploadXls, PaymentPendingRow },
    components : { SelectMarking, PaymentRow, PaymentPendingRowCard },
    props: {
        paymentPendingId : Number
    },     
    data: () => ({
        markingIdSelected : '',
        payments : [],
        loadingSearch : false,
        dateFromTo: '',
        dateFrom: '',
        dateTo: '',
        paymentId: 0
    }),

    methods: {
        getPaymentPayNoDetail: function(){
            this.payments = []
            this.loadingSearch = true

            HTTP.post('payment/history/pay-no-detail', {
                markingHeaderId: this.markingIdSelected,
                dateCreateFrom : this.dateFrom,
                dateCreateTo : this.dateTo
            })
            .then(response => {
                let parent = this;
                console.log(JSON.stringify(response.data))
                this.payments = response.data
                // _.forEach(response.data, function(value) {
                //     let markingheadercode = ""
                //     if(value.payment){
                //         markingheadercode = value.payment.marking_header.markingheadercode
                //     }
                //     let paymentPending = {
                //         id : value.id,
                //         amount : value.amount,
                //         markingheadercode : markingheadercode,
                //         createdby : value.createdby,
                //         created_at : value.created_at,
                //         transactionDate : value.transactionDate,
                //         payment : value.payment 
                //     }
                //     parent.paymentPendings.push(paymentPending);
                // });
                this.loadingSearch = false;
            })
            .catch(e => {
                this.loadingSearch = false;
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })            
        },  
        onSelectedMarking: function(markingHeaderId){
            this.markingIdSelected = markingHeaderId
        },
        postAssignPayment: function(payment){

            // console.log(JSON.stringify(payment))

            HTTP
            .post('paymentPending/assignToPayment', {
                id: this.paymentPendingId,
                paymentId : payment.id
            })
            .then(response => {
    
                this.$Message.success({
                    content: 'Assign Berhasil',
                    duration: 5
                });

                this.$router.push({ path: '/payment/paymentPending/list' })
                
            })
            .catch(e => {

                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
            
        }

    },
    watch: {
        dateFromTo: function(val, oldVal) {
            // this.dataUpload.bankAccountId = val;
            this.dateFrom = moment(val[0]).format('YYYY/MM/DD')
            this.dateTo = moment(val[1]).format('YYYY/MM/DD')
        }
    },
    
    mounted() {
        // this.getPaymentPendingByFilter();
    },
    created() {  
    }
}

</script>
<style>
</style>



// WEBPACK FOOTER //
// PaymentPendingAssign.vue?2b1eac00